import React, { forwardRef } from 'react';
import styles from './Input.module.css';

/**
 * Input Component
 * Supports text, email, password, number, date, etc.
 * Optional icon, error state, helper text
 */
const Input = forwardRef(({
    label,
    id,
    type = 'text',
    placeholder,
    value,
    onChange,
    error,
    helperText,
    icon,
    disabled = false,
    required = false,
    className = '',
    ...props
}, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <div className={`${styles.wrapper} ${className}`}>
            {label && (
                <label htmlFor={inputId} className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}
            <div className={`${styles.inputWrapper} ${error ? styles.hasError : ''}`}>
                {icon && <span className={styles.icon}>{icon}</span>}
                <input
                    ref={ref}
                    id={inputId}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    required={required}
                    className={styles.input}
                    aria-invalid={error ? 'true' : 'false'}
                    aria-describedby={error || helperText ? `${inputId}-helper` : undefined}
                    {...props}
                />
            </div>
            {(error || helperText) && (
                <p
                    id={`${inputId}-helper`}
                    className={error ? styles.errorText : styles.helperText}
                >
                    {error || helperText}
                </p>
            )}
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
